import {Animated} from 'react-native';

export const startSlideUpDownAnimations = (animation: any) => {
  Animated.sequence([
    Animated.timing(animation, {
      toValue: -16,
      duration: 100,
      useNativeDriver: true,
    }),
    Animated.timing(animation, {
      toValue: 0,
      duration: 100,
      useNativeDriver: true,
    }),
  ]).start();
};

export const startShakeAnimations = (animation: any) => {
  Animated.sequence([
    Animated.timing(animation, {
      toValue: 16,
      duration: 60,
      useNativeDriver: true,
    }),
    Animated.timing(animation, {
      toValue: -16,
      duration: 60,
      useNativeDriver: true,
    }),
    Animated.timing(animation, {
      toValue: 16,
      duration: 60,
      useNativeDriver: true,
    }),
    Animated.timing(animation, {
      toValue: 0,
      duration: 60,
      useNativeDriver: true,
    }),
  ]).start();
};

export const startOpacityAnimation = (animation: any) => {
  Animated.sequence([
    Animated.timing(animation, {
      toValue: 0.2,
      duration: 80,
      useNativeDriver: true,
    }),
    Animated.timing(animation, {
      toValue: 0.5,
      duration: 80,
      useNativeDriver: true,
    }),
    Animated.timing(animation, {
      toValue: 1,
      duration: 80,
      useNativeDriver: true,
    }),
  ]).start();
};
